export default __webpack_public_path__ + "static/media/Cubistry.80216ac9.png";